import React, {useEffect, useState, useCallback, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {Menu} from '../../utils/menu/Menu';
import {formatErrors} from '../../constants';
import {toast} from 'react-toastify';
import {SortItem} from '../../utils/sortItem/SortItem';
import {ButtonMore} from '../../utils/buttonMore/buttonMore';
import {Pagination} from '../../utils/pagination/Pagination';
import {ConfirmModal} from "../../utils/confirm/ConfirmModal";
import { deleteFaqSettingsAction, getFaqSettingsAction } from '../../actions/faqAction';
import { InputSearch } from '../../utils/inputSearch/InputSearch';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { FaqSettingsModal } from './utils/FaqSettingsModal';


const FaqSettings = (props) => {
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({});
  const abortRef = useRef(null);

  const handleChangeFilter = useCallback((field, value) => {
      setFilter((data) => {
        return {...data, [field]: value, page: 1}
      });
    }, []);

  const handleChangePage = useCallback((value) => {
    setFilter((data) => {
      return {...data, page: value}
    });
  }, []);

  // get list
  const getList = useCallback((filter) => {
    if (abortRef && abortRef.current) {
      abortRef.current.abort();
    }
    const abortNew = new AbortController();
    abortRef.current = abortNew;
    dispatch(getFaqSettingsAction(filter, abortRef && abortRef.current ? abortRef.current.signal : null)).then((data) => {
      abortRef.current = null;
      setItems(data.items || []);
      setTotal(data.total);
      localStorage.setItem('dc_FaqSettingsFilter', JSON.stringify(filter));
    }).catch(err => {
      if (err.name !== 'AbortError') {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      }
      abortRef.current = null;
    });
  }, [dispatch]);

  const handleDelete = (id) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      dispatch(deleteFaqSettingsAction(id)).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Настройка удалена', {position: toast.POSITION.BOTTOM_RIGHT});
        if (filter.page > 1 && (filter.page - 1) * filter.limit >= total - 1) {
          setFilter({...filter, page: filter.page - 1});
        } else {
          getList(filter);
        }
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  // get list on change filter
  useEffect(() => {
    if (filter.page) {
      getList(filter);
    }
  }, [filter, getList]);

  useEffect(() => {
    const baseFilter = {page: 1, limit: 10, search: ''};
    let curFilter = localStorage.getItem('dc_FaqSettingsFilter');
    curFilter = curFilter ? JSON.parse(curFilter) : baseFilter;
    curFilter.page = !curFilter.page ? 1 : curFilter.page;
    setFilter(curFilter);
  }, []);

  return <div className="content">
    <Menu isStatic={true}/>

    <div className="heading heading--flex">
      <h2 className="heading__title">
        Настройки базы знаний
      </h2>
      {filter.page && filter.page > 0 && <InputSearch className="heading__input"
                                                      value={filter.search}
                                                      loading={loading}
                                                      handleChange={handleChangeFilter} />}
      
      {filter.page && <FaqSettingsModal onSuccess={() => getList(filter)} triggerWrap={true} trigger={<button type="button" className="heading__btn heading__btn--invite btn modal-btn">+ Добавить</button>} />}
      <Link to="/faq-categories" className="heading__btn heading__btn--invite btn modal-btn" style={{"marginLeft": "10px"}}>Категории</Link>
    </div>
    <div className="users">
      <div className="users__wrapper">
        <div className="sort">
          <SortItem title="Название" className="sort__item--name"/>
          <SortItem title="Значение" className="sort__item--name"/>
          <SortItem title="Уникальное имя" className="sort__item--email"/>
          
        </div>
        <div className="users__inner">
          {
            items && items.length > 0 && items.map((i) => <div key={i.id} className="users__item">
              <span className="users__name">{i.title}</span>
              <span className="users__name">{i.value}</span>
              <span className="users__email">{i.uniq_name}</span>
              
              <ButtonMore>
                <ul className="dropdown">
                  <li>
                    <FaqSettingsModal trigger={<div className="dropdown__item icon-edit">Редактировать</div>} triggerWrap={false} item={i} onSuccess={() => getList(filter)}/>
                  </li>
                  <li>
                    <ConfirmModal trigger={<div className="dropdown__item icon-delete">Удалить</div>} triggerWrap={false} title={"Удалить настройку?"} handleOk={() => handleDelete(i.id)}/>
                  </li>
                </ul>
              </ButtonMore>
            </div>)
          }
        </div>
      </div>
    </div>

    {filter.page && filter.page > 0 && <Pagination page={filter.page} total={total} limit={filter.limit} onChange={handleChangePage}/>}
  </div>;
};


export default FaqSettings
